var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgE9Abf0Ec4A717184E499Ca220B6Cc5D3646Bc0A7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20.6667 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.240762 0.349227C0.600184 -0.0700991 1.23148 -0.118661 1.65081 0.240762L10.3334 7.68294L19.0159 0.240762C19.4352 -0.11866 20.0665 -0.0700982 20.4259 0.349228C20.7854 0.768553 20.7368 1.39985 20.3175 1.75928L10.9841 9.75927C10.6097 10.0803 10.057 10.0803 9.68256 9.75927L0.349227 1.75927C-0.0700991 1.39985 -0.118661 0.768552 0.240762 0.349227Z",
    fill: "var(--fill-0, white)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE9Abf0Ec4A717184E499Ca220B6Cc5D3646Bc0A7);
export default __webpack_public_path__ + "static/media/e9abf0ec4a717184e499ca220b6cc5d3646bc0a7.705f450488042a033b97c599ca90f0f5.svg";
export { ForwardRef as ReactComponent };